<template>
  <el-select
    v-model="value"
    placeholder="请选择机构"
    clearable
    @change="changeValue($event)"
  >
    <el-option
      v-for="item in partyGroup"
      :key="item.code"
      :label="item.groupName"
      :value="item.code"
    />
  </el-select>
</template>
<script>
export default {
  data() {
    return {
      value: '',
      partyGroup: [],
      callbackMethod: ''
    }
  },
  // created() {
  //   this.getPartyGroup()
  // },
  methods: {
    // getPartyGroup() {
    //   request({
    //     url: '/ntocc-basic-api/partyGroup/getPartyGroup',
    //     method: 'get'
    //   }).then(response => {
    //     this.partyGroup = response.data
    //   })
    // },
    changeValue(e) {
      this.$emit(this.callbackMethod, this.value)
    },
    setSelectValue(value) {
      this.value = value
    },
    initData(partyGroup, callbackMethod) {
      this.partyGroup = partyGroup
      this.callbackMethod = callbackMethod
    }
  }
}
</script>
